/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { NgModule, Provider, Type } from '@angular/core';
import { checkoutB2BTranslationsEn, checkoutB2BTranslationsEs } from '@spartacus/checkout/b2b/assets';
import { CheckoutB2BRootModule } from '@spartacus/checkout/b2b/root';
import { checkoutTranslationsEn, checkoutTranslationsEs } from '@spartacus/checkout/base/assets';
import { CHECKOUT_FEATURE, CheckoutRootModule } from '@spartacus/checkout/base/root';
import {
  checkoutScheduledReplenishmentTranslationChunksConfig,
  checkoutScheduledReplenishmentTranslationsEn,
  checkoutScheduledReplenishmentTranslationsEs,
} from '@spartacus/checkout/scheduled-replenishment/assets';
import { CheckoutScheduledReplenishmentRootModule } from '@spartacus/checkout/scheduled-replenishment/root';
import { provideConfig } from '@spartacus/core';
import { environment } from '../../../../environments/environment';

const extensionModules: Type<any>[] = [];
const extensionProviders: Provider[] = [];

if (environment.b2b) {
  extensionModules.push(CheckoutB2BRootModule, CheckoutScheduledReplenishmentRootModule);

  extensionProviders.push(
    provideConfig({
      i18n: {
        resources: { en: checkoutB2BTranslationsEn, es: checkoutB2BTranslationsEs },
      },
    })
  );
  extensionProviders.push(
    provideConfig({
      i18n: {
        resources: { en: checkoutScheduledReplenishmentTranslationsEn, es: checkoutScheduledReplenishmentTranslationsEs },
        chunks: checkoutScheduledReplenishmentTranslationChunksConfig,
      },
    })
  );
}

@NgModule({
  imports: [CheckoutRootModule, ...extensionModules],
  providers: [
    provideConfig({
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () => import('./checkout-wrapper.module').then((m) => m.CheckoutWrapperModule),
        },
      },
    }),
    provideConfig({
      i18n: {
        resources: { en: checkoutTranslationsEn, es: checkoutTranslationsEs },
      },
    }),
    ...extensionProviders,
  ],
})
export class CheckoutFeatureModule {}
